var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 23",
    style: {
      enableBackground: "new 0 0 24 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#042b62;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,12.8L9.1,6.4C9,5.9,8.6,5.7,8.2,5.7H3.4c-0.4,0-0.8,0.2-1,0.6l-2.3,6.5c-0.2,0.5,0,1,0.5,1.2 c0.1,0.1,0.3,0.1,0.4,0.1c0.4,0,0.8-0.2,0.9-0.6L3,10.3V11l-1.4,4.9c0,0.3,0.1,0.6,0.4,0.7c0.1,0.1,0.2,0.1,0.3,0.1h0.7v5.2 c0,0.6,0.5,1.2,1.1,1.2c0.7,0,1.2-0.5,1.2-1.2V17c0-0.2,0.2-0.4,0.4-0.4l0,0c0.2,0,0.4,0.2,0.4,0.4v4.8c0,0.6,0.5,1.2,1.1,1.2 c0.7,0,1.2-0.5,1.2-1.2v-5.2h0.7c0.1,0,0.2,0,0.3-0.1c0.3-0.1,0.4-0.4,0.4-0.7L8.5,11v-0.7l1.1,3.2c0.1,0.4,0.5,0.6,0.9,0.6 c0.1,0,0.3,0,0.4-0.1C11.4,13.8,11.6,13.3,11.4,12.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.8,0.8c1.2,0,2.1,0.9,2.1,2.1S6.9,5,5.8,5S3.7,4,3.7,2.9S4.6,0.8,5.8,0.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,0c1.1,0,2.1,0.9,2.1,2.1s-0.9,2.1-2.1,2.1s-2.1-0.9-2.1-2.1S17.4,0,18.5,0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,13.4l-0.5-7.7c0-0.5-0.5-0.9-1-0.9h-6.8c-0.5,0-0.9,0.4-1,0.9l-0.5,7.7c0,0.5,0.4,1,0.9,1 c0.5,0,1-0.4,1-0.9l0.4-5.2l0,13.3c0,0.6,0.5,1.1,1.1,1.2c0.6,0,1.2-0.5,1.2-1.1v-7.1c0-0.2,0.2-0.4,0.4-0.4l0,0 c0.2,0,0.4,0.2,0.4,0.4v7.1c0,0.6,0.5,1.1,1.1,1.2c0.6,0,1.2-0.5,1.2-1.1l0-13.1l0.3,5c0,0.5,0.5,0.9,1,0.9 C23.1,14.4,23.5,13.9,23.4,13.4z M19.3,9.3l-0.5,0.8c-0.1,0.2-0.3,0.2-0.5,0l-0.5-0.8c0-0.1-0.1-0.1,0-0.2l0.5-2.5l-0.3-0.3 c-0.1-0.1-0.1-0.3,0-0.4l0.4-0.4c0.1-0.1,0.3-0.1,0.4,0l0.4,0.4c0.1,0.1,0.1,0.3,0,0.4l-0.3,0.3l0.5,2.5C19.3,9.2,19.3,9.3,19.3,9.3 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpouse);
export default __webpack_public_path__ + "static/media/spouse.d7ff05cce7266047e692ed1ca12ea24d.svg";
export { ForwardRef as ReactComponent };